import { NgModule } from '@angular/core';
import { CoalesceToPipe } from './pipes/coalesce-to.pipe';
import { CommonModule } from '@angular/common';
import { ButtonBusyDirective } from './directives/button-busy.directive';
import { AppComponentBaseDirective } from './directives/app-component-base.directive';
import { LocalizePipe } from './pipes/localize.pipe';
import { DateTimeSelectComponent } from './components/date-time-select/date-time-select.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { PhoneNumberComponent } from './components/phone-number/phone-number.component';
import { EqualValidator } from './directives/equal-validator.directive';
import { LanguageSelectComponent } from './components/language-select/language-select.component';

const pipes = [
  CoalesceToPipe,
  LocalizePipe
];
const directives = [
  ButtonBusyDirective,
  EqualValidator
];
const components = [
  DateTimeSelectComponent,
  PhoneNumberComponent,
  LanguageSelectComponent
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot()
  ],
  exports: [
    ...pipes,
    ...directives,
    ...components,
  ],
  declarations: [
    ...pipes,
    ...directives,
    ...components
  ],
  providers: [],
})
export class SharedModule { }
